import React from 'react'

/**
 * withTwoPassRenderer is an HOC which adds a key onto the wrapped component.
 * The key is initially set to `'server'` which is changed to `'client'`
 * once the component is mounted. This twice rendering is done to avoid gatsby's hydration issue.
 * Please refer https://reactjs.org/docs/react-dom.html#hydrate and
 * https://github.com/gatsbyjs/gatsby/discussions/17914 for more info.
 */
export const withTwoPassRenderer = <P extends Record<string, any>>(
  Component: React.ComponentType<P>
): React.FC<P> => {
  const displayName = Component.displayName || Component.name || 'Component'

  const TwoPassRenderer: React.FC<P> = (props) => {
    const [renderMode, setRenderMode] = React.useState('server')

    React.useEffect(() => {
      setRenderMode('client')
    }, [])

    return <Component key={renderMode} {...(props as P)} />
  }

  TwoPassRenderer.displayName = `withTwoPassRenderer(${displayName})`

  return TwoPassRenderer
}
